import { useLocation } from "react-router-dom";

export const EnergyBotScreen = () => {
  const { headlessEnrollmentUrl } = useLocation().state;

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src={headlessEnrollmentUrl}
        title="EnergyBot"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};
